import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import TopBackButton from '../common/top-back-button';
import Container from '@mui/material/Container';
import { SFPalette } from '@/lib/color';
import Stack from '@mui/material/Stack';
import SFUploadIcon from '../icons/sf-upload-icon';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import BottomFix from '../common/bottom-fix';

export default function SendLinkModal({
  link = '생성된 링크 주소 노출',
  open,
  onClose,
}: {
  link?: string;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box bgcolor="white" width="100%" height="100%">
        <Container
          maxWidth="sm"
          sx={{
            textAlign: 'center',
          }}
        >
          <TopBackButton
            rightItem={
              <IconButton
                sx={{
                  color: 'text.primary',
                  p: 0,
                }}
                onClick={onClose}
              >
                <Close />
              </IconButton>
            }
            title="링크 전송"
            useBackButton={false}
            boxProps={{
              mb: 12,
            }}
          />
          <Stack
            width={80}
            height={80}
            bgcolor={SFPalette.shuffleColor}
            borderRadius="50%"
            justifyContent={'center'}
            alignItems={'center'}
            mx="auto"
            mb={3}
          >
            <SFUploadIcon />
          </Stack>
          <Typography variant="h4" fontWeight={700} mb={2}>
            요청 링크를
            <br />
            전송할 수 있습니다.
          </Typography>
          <Typography variant="subtitle2" mb={5}>
            이 링크를 친구에게 보내세요!
          </Typography>
          <Typography mb={18} variant="subtitle2">
            {link}
          </Typography>
        </Container>
        <BottomFix>
          <Stack gap={1} py={2}>
            <Button size="large" fullWidth variant="outlined">
              클립보드로 복사
            </Button>
            <Button size="large" fullWidth variant="outlined">
              QR 코드
            </Button>
          </Stack>
        </BottomFix>
      </Box>
    </Modal>
  );
}
